import { HTMLInputTypeAttribute } from 'react'

interface Props {
  label: string
  id: string
  placeholder?: string
  name?: string
  type?: HTMLInputTypeAttribute
  errorMessage?: string | null
}

const Input = ({
  label,
  id,
  placeholder,
  name,
  type = 'text',
  errorMessage,
}: Props) => (
  <>
    <label htmlFor={id} hidden aria-hidden="true" className="hidden">
      {label}
    </label>
    <input
      id={id}
      name={name || id}
      placeholder={placeholder}
      type={type}
      required
      className={`border bg-black text-[13px] rounded px-[26px] h-11 text-white w-full outline-none appearance-none ${
        errorMessage
          ? 'focus:border-[#ff3547] border-[#ff3547]'
          : 'focus:border-[#6ebb1d] border-[#4A4D4E] mb-4'
      }`}
    />
    <p
      className={`text-sm text-[#ff3547] text-center ${
        errorMessage
          ? 'visible opacity-100 h-full p-2'
          : 'invisible opacity-0 h-0'
      } transition-all duration-300`}
    >
      {errorMessage}
    </p>
  </>
)

export default Input
